import { render, staticRenderFns } from "./staffSetting.vue?vue&type=template&id=0da47de6&scoped=true&"
import script from "./staffSetting.vue?vue&type=script&lang=js&"
export * from "./staffSetting.vue?vue&type=script&lang=js&"
import style0 from "./staffSetting.vue?vue&type=style&index=0&id=0da47de6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da47de6",
  null
  
)

export default component.exports